(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baserange-help-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const helpMenuDropdown = document.getElementById('help-menu-dropdown');
  if (!helpMenuDropdown) return;

  const summary = helpMenuDropdown.querySelector('summary');
  // Tablettes (touch) + small laptops
  const mq = window.matchMedia(
    '(hover: none) and (pointer: coarse), (max-width: 1180px)'
  );

  function apply(isTouchLayout) {
    if (isTouchLayout) {
      helpMenuDropdown.removeAttribute('open');
      if (summary) summary.style.display = 'flex';
    } else {
      helpMenuDropdown.setAttribute('open', '');
      if (summary) summary.style.display = 'none';
    }
  }

  apply(mq.matches);

  if (mq.addEventListener) {
    mq.addEventListener('change', (e) => apply(e.matches));
  } else {
    mq.addListener((e) => apply(e.matches)); // vieux Safari
  }
});

  } catch(e) { console.error(e); }
})();
})();
